import supabase from '../lib/supabaseClient';

const TABLE='review_feedback_1700000000002';

export async function submitReviewFeedback(business,feedback) {
  const message=feedback.message.trim();
  const contact=feedback.contact.trim();
  if (!business?.place_id || ![1,2,3,4].includes(feedback.rating) || message.length < 10) {
    throw new Error('Please select a rating and write at least 10 characters of feedback.');
  }
  const {error}=await supabase.from(TABLE).insert({
    place_id: business.place_id,
    business_name: business.business_name,
    rating: feedback.rating,
    message,
    contact
  });
  if (error) throw new Error(error.message);
}